var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.91 36.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #353535;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #353535;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "livetype"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.5,
    y1: 35,
    x2: 37.41,
    y2: 35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.04,29.09c-1.32,0-2.4-1.07-2.4-2.4V2.4c0-1.32,1.07-2.4,2.4-2.4s2.4,1.07,2.4,2.4V26.69c0,1.32-1.07,2.4-2.4,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.87,29.09c-1.32,0-2.4-1.07-2.4-2.4V12.3c0-1.32,1.07-2.4,2.4-2.4s2.4,1.07,2.4,2.4v14.39c0,1.32-1.07,2.4-2.4,2.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.1b3c162710f9c734fcd4f8367a6e8585.svg";
export { ForwardRef as ReactComponent };